import { routerReducer as routing } from 'react-router-redux';

import account from 'reducers/account/account';
import ads from 'reducers/ads';
import autoComplete from 'reducers/autoComplete';
import payment from 'reducers/account/payment';
import authentication from 'reducers/authentication';
import drop from 'reducers/drop';
import eGiftCards from 'reducers/eGiftCards';
import facets, { isFacetsVisible } from 'reducers/search/facets';
import filters from 'reducers/search/filters';
import products from 'reducers/search/products';
import searchLayout from 'reducers/search/searchLayout';
import cookies from 'reducers/cookies';
import responseCookies from 'reducers/responseCookies';
import client from 'reducers/client';
import meta from 'reducers/meta';
import product from 'reducers/detail/productDetail';
import sharing from 'reducers/detail/sharing';
import headerFooter from 'reducers/headerfooter';
import shipping from 'reducers/account/shipping';
import order from 'reducers/account/order';
import orders from 'reducers/account/orders';
import returns from 'reducers/account/returns';
import hearts from 'reducers/hearts';
import ask from 'reducers/ask/ask';
import hmdSurvey from 'reducers/ask/hmdSurvey';
import brandPage from 'reducers/brand/brandPage';
import cart from 'reducers/cart/cart';
import dontForget from 'reducers/dontForget';
import influencer from 'reducers/influencer/influencer';
import landingPage from 'reducers/landing/landingPage';
import microsoftUetTag from 'reducers/microsoftUetTag';
import newsfeed from 'reducers/landing/newsfeed';
import iframe from 'reducers/landing/iframe';
import recos from 'reducers/recos';
import pixelServer from 'reducers/pixelServer';
import { error } from 'reducers/errors';
import pageLoad from 'reducers/pageLoad';
import pageView from 'reducers/pageView';
import redirect from 'reducers/redirect';
import rewards from 'reducers/account/rewards';
import reviews from 'reducers/reviews/reviews';
import shipmentTracking from 'reducers/shipmentTracking';
import sizeGroups from 'reducers/sizeGroups';
import subscriptionsInfo from 'reducers/subscriptionsInfo';
import sizingChooser from 'reducers/detail/sizingChooser';
import appAdvertisement from 'reducers/appAdvertisement';
import notifications from 'reducers/notifications';
import holmes from 'reducers/holmes';
import raffle from 'reducers/landing/raffle';
import wildCard from 'reducers/wildCard';
import zfcSessionId from 'reducers/zfcSessionId';
import localStorage from 'reducers/localStorage';
import exchange from 'reducers/account/exchange';
import outfits from 'reducers/outfits';
import amethyst from 'reducers/amethyst';
import instagram from 'reducers/instagram';
import feedback from 'store/ducks/feedback/reducer';
import shipOption from 'store/ducks/shipOption/reducer';
import history from 'store/ducks/history/reducer';
import checkoutData from 'store/ducks/checkout/reducer';
import sharedPayment from 'store/ducks/payment/reducer';
import sharedRewards from 'store/ducks/rewards/reducer';
import address from 'store/ducks/address/reducer';
import exchangesData from 'store/ducks/exchanges/reducer';
import giftOptions from 'store/ducks/giftoptions/reducer';
import meetSanta from 'store/ducks/santa/reducer';
import search from 'store/ducks/search/reducer';
import killswitch from 'store/ducks/killswitch/reducer';

// please alphabetize
export default {
  exchangesData,
  account,
  address,
  ads,
  amethyst,
  appAdvertisement,
  ask,
  hmdSurvey,
  authentication,
  autoComplete,
  brandPage,
  cart,
  client,
  cookies,
  dontForget,
  drop,
  eGiftCards,
  environmentConfig: (state = {}) => state,
  error,
  exchange,
  facets,
  feedback,
  giftOptions,
  hearts,
  filters,
  headerFooter,
  history,
  holmes,
  iframe,
  influencer,
  instagram,
  isFacetsVisible,
  killswitch,
  landingPage,
  localStorage,
  checkoutData,
  meta,
  microsoftUetTag,
  newsfeed,
  notifications,
  order,
  orders,
  outfits,
  pageLoad,
  pageView,
  payment,
  pixelServer,
  product,
  products,
  raffle,
  recos,
  redirect,
  responseCookies,
  returns,
  reviews,
  rewards,
  routing,
  meetSanta,
  search,
  searchLayout,
  sharedPayment,
  sharedRewards,
  sharing,
  shipmentTracking,
  shipOption,
  shipping,
  sizeGroups,
  sizingChooser,
  subscriptionsInfo,
  url: (state = {}) => state,
  wildCard,
  zfcSessionId
};
